/**
 * Footer Component
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.scss';

const Footer = () => {
  const { t } = useTranslation();
  const yr = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__grid">
          {/* Brand */}
          <div>
            <div className="footer__logo">
              <img src="/logo-128.png" alt="MyWeddingWiz.com" style={{ height: 42, marginRight: 8, verticalAlign: 'middle' }} />
              <span className="footer__logo-my">My</span><span className="footer__logo-wedding">Wedding</span><span className="footer__logo-accent">Wiz</span><span className="footer__logo-dot">.com</span>
            </div>
            <p className="footer__description">{t('footer.description')}</p>
            <div className="footer__social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="footer__social-link">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="footer__social-link">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer" aria-label="Pinterest" className="footer__social-link">
                <i className="bi bi-pinterest"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="footer__social-link">
                <i className="bi bi-twitter-x"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="footer__title">{t('footer.quickLinks')}</h4>
            <ul className="footer__links">
              <li><Link to="/vendors">{t('nav.vendors')}</Link></li>
              <li><Link to="/venues">{t('nav.venues')}</Link></li>
              <li><Link to="/planning-tools">{t('nav.planningTools')}</Link></li>
            </ul>
          </div>

          {/* For Vendors */}
          <div>
            <h4 className="footer__title">{t('footer.forVendors')}</h4>
            <ul className="footer__links">
              <li><Link to="/register?role=vendor">{t('footer.vendorSignup')}</Link></li>
              <li><Link to="/login">{t('footer.vendorLogin')}</Link></li>
              <li><Link to="/planning-tools">{t('footer.resources')}</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="footer__title">{t('footer.support')}</h4>
            <ul className="footer__links">
              <li><Link to="/about">{t('nav.about')}</Link></li>
              <li><Link to="/contact">{t('footer.helpCenter')}</Link></li>
              <li><Link to="/contact">{t('footer.faq')}</Link></li>
              <li><Link to="/contact">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="footer__title">{t('footer.legal')}</h4>
            <ul className="footer__links">
              <li><Link to="/privacy-policy">{t('footer.privacyPolicy')}</Link></li>
              <li><Link to="/terms-of-service">{t('footer.termsOfService')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p>{t('footer.copyright', { year: yr })}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
